import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { stringify } from 'qs';
import { boolean } from 'yup';

const captchaSecretKey = process.env.REACT_APP_CAPTCHA_SECRET_KEY;
const domainUrl = process.env.REACT_APP_API_BASE_URL;
const config: AxiosRequestConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
  },
};
export type VerifyingType= {
  success: boolean, // whether this request was a valid reCAPTCHA token for your site
  score?: number, // the score for this request (0.0 - 1.0)
  action?: string, // the action name for this request (important to verify)
  hostname?: string, // the hostname of the site where the reCAPTCHA was solved
  // challenge_ts: any, // timestamp of the challenge load (ISO format yyyy-MM-dd'T'HH:mm:ssZZ)
};

const verifyingTheUserResponseByTokenApi = async (token: string): Promise<VerifyingType> => {
  const params = {
    secret: captchaSecretKey,
    response: token,
  };
  const { data } = await axios.post(`${domainUrl}/v1/recaptcha?${stringify(params)}`, {});
  return data;
};
export default verifyingTheUserResponseByTokenApi;
